import { render, staticRenderFns } from "./menuPage.vue?vue&type=template&id=b131e042&scoped=true&"
import script from "./menuPage.vue?vue&type=script&lang=js&"
export * from "./menuPage.vue?vue&type=script&lang=js&"
import style0 from "./menuPage.vue?vue&type=style&index=0&id=b131e042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b131e042",
  null
  
)

export default component.exports